var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogContainer"},[_c('div',[_c('h2',[_vm._v("提示：")]),_c('p',[_vm._v(_vm._s(_vm.dialogData.msg))]),_c('div',[_c('div',{on:{"click":_vm.queren}},[_vm._v("确认")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeBtn),expression:"closeBtn"}],staticClass:"close",on:{"click":_vm.quxiao}},[_vm._v("取消")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }